import React, { Component } from "react";

export class ContentContainer extends Component {
    render() {
        const { size, containerClassName, style } = this.props;

        return (
            <section className={`space--${size || "sm"}`} style={style}>
                <div className={`container ${containerClassName || ""}`}>
                    {this.props.children}
                </div>
            </section>
        );
    }
}